import * as React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function MeetTheTeam() {
  return <section id="meettheteam" className="bg-background py-24 sm:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="flex flex-col items-center text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-bold font-default text-foreground tracking-tight mb-6">
            Meet the Team
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans max-w-2xl leading-relaxed">
            The skilled professionals behind AD Electrical. We are dedicated to providing safe, reliable, and high-quality electrical services for every project, bringing years of industry expertise to your doorstep.
          </p>
        </div>

        <div className="w-full max-w-5xl mx-auto relative">
          {}
          <div className="absolute -inset-1 bg-accent/30 rounded-lg blur-md opacity-70"></div>
          
          <div className="relative rounded-lg overflow-hidden border border-border shadow-2xl bg-card">
            <AspectRatio ratio={16 / 9}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678780/img/DSC06327.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678780/img/DSC06327.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678780/img/DSC06327.jpg-wvc-sizes" alt="AD Electrical Team" className="object-cover w-full h-full contrast-125 saturate-50 hover:saturate-100 transition-all duration-700 ease-in-out" loading="lazy" />
            </AspectRatio>
          </div>
        </div>
      </div>
    </section>;
}